import React, {useEffect} from 'react';
import {TabButton, TabRadio, TabRadioLabel, TabsContainer} from './styled';
import {Layout, Text} from '@phonectas/unifon-ui-kit';
import {useTranslation} from 'react-i18next';

interface CustomTabsProps {
	items: {value: string; label: string; disabled: boolean}[];
	active: string;
	onChange: (value: string) => void;
	radio?: boolean;
}

const CustomTabs: React.FC<CustomTabsProps> = ({
	items,
	active,
	onChange,
	radio = false,
}) => {
	const [t] = useTranslation();

	useEffect(() => {
		const activeTabObj = items.find((tab) => tab.value === active);
    	const firstEnabledTab = items.find((tab) => !tab.disabled);

		if (!activeTabObj || activeTabObj.disabled) {
			if (firstEnabledTab) {
				onChange(firstEnabledTab.value);
			} else {
				onChange('');
			}
		}
	}, [items, active, onChange]);

	const allTabsDisabled = items.every((tab) => tab.disabled);

	if (allTabsDisabled) {
		return (
			<Layout fullWidth justifyContent="center" alignItems="center" style={{padding: '16px'}}>
				<Text>
					{t('No available upsell opportunities.')}
				</Text>
			</Layout>
		);
	}

	return (
		<>
			{
				radio ? (
					<TabsContainer role="radiogroup">
						{items.map((tab, idx) => (
							<TabRadioLabel
								key={tab.value}
								$active={active === tab.value}
								$first={idx === 0}
								$last={idx === items.length - 1}
								disabled={tab.disabled}
							>
								<TabRadio
									name="custom-tabs"
									value={tab.value}
									checked={active === tab.value}
									disabled={tab.disabled}
									onChange={() => !tab.disabled && onChange(tab.value)}
								/>
								<span
									style={{
										textDecoration: tab.disabled ? 'line-through' : 'none',
									}}
								>
									<Text
										style={{
											color: tab.disabled ? 'gray' : active === tab.value ? '#fff' : '#001B74'}}
									>
										{tab.label}
									</Text>
								</span>
							</TabRadioLabel>
						))}
					</TabsContainer>
				) : (
					<TabsContainer>
						{items.map((tab) => (
							<TabButton
								key={tab.value}
								$active={active === tab.value}
								onClick={() => !tab.disabled && onChange(tab.value)}
								type="button"
								disabled={tab.disabled}
								aria-disabled={tab.disabled}
							>
								{tab.disabled ? (
									<span
										style={{
											color: 'gray',
											textDecoration: 'line-through',
										}}
									>
										{tab.label}
									</span>
								) : (
									<span>{tab.label}</span>
								)}
							</TabButton>
						))}
					</TabsContainer>
				)
			}
		</>
	);
};

export default CustomTabs;

